import React from 'react';
import styled from 'styled-components';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import swal from 'sweetalert';

import { logout } from '../../redux/login';
import MenuItem from './MenuItem';
import logo from '../../svg/nc-logo.svg';
import { fetchBusinessInfo } from '../../redux/business';
import { imageFix } from '../../helpers';
import { Col, Row } from '../Grid';
import { AnalyticsService } from '../../services/AnalyticsService';

const BrandName = styled.div`
  font-family: BrandonGrotesque-Regular;
  font-size: 15px;
  font-weight: 900;
  color: var(--color-greyish-brown);
  letter-spacing: 2.9px;
  margin-right: 20px;
  margin-top: 30px;
  max-width: 180px;
`;

const Logo = styled.img`
  display: block;
  margin: 30px auto 0;
  ${(props) => (props.mini ? 'width: 50%;' : null)}
`;

const Container = styled.aside`
  flex: 0 0 auto;
  background-color: ${(props) => (props.mobile ? '#ffffff' : '#fafafa')};
  ${(props) => (props.mobile ? '' : 'box-shadow: 0 4px 6px 0 hsla(0, 0%, 0%, 0.2)')};
  @media print {
    display: none !important;
  }
`;

interface Props {
  page: string;
  business: Business;
  logout: Function;
  mobile?: boolean;
  push: Function;
  fetchBusinessInfo: Function;
}

class Sidebar extends React.Component<Props, {}> {
  componentDidMount() {
    if (!this.props.business.name) this.props.fetchBusinessInfo();
  }

  logout() {
    swal('Are you sure you want to logout?', {
      buttons: [true, true],
    }).then((result) => {
      if (result) {
        AnalyticsService.track('Logging out', {});
        this.props.logout();
      }
    });
  }

  visit(name, url) {
    AnalyticsService.track(name + ' tap', {});
    this.props.push(url);
  }

  render() {
    const isMini = this.props.page === 'monthlyReport' && !this.props.mobile;
    const avatar =
      this.props.business.media && this.props.business.media.length > 0
        ? imageFix(this.props.business.media[0].path)
        : undefined;

    const businessLogo = (
      <img
        src={avatar}
        alt="Brand logo"
        width="50"
        height="50"
        style={{ display: 'block', margin: '0 auto 50px', marginTop: '30px' }}
      />
    );

    return (
      <Container mini={isMini} mobile={this.props.mobile}>
        {!this.props.mobile && <Logo src={logo} alt="Neon Coat logo" mini={isMini} />}
        {isMini && avatar !== undefined ? (
          businessLogo
        ) : (
          <Row>
            {avatar !== undefined ? <Col size="0 0 86px">{businessLogo}</Col> : null}
            <Col size="1">
              <BrandName>
                {this.props.business.name ? this.props.business.name.toUpperCase() : 'Loading...'}
              </BrandName>
            </Col>
          </Row>
        )}
        <MenuItem
          text="Dashboard"
          icon="dashboard"
          active={this.props.page === 'dashboard'}
          onClick={() => this.visit('Dashboard', '/')}
          mini={isMini}
        />
        <MenuItem
          text="Results"
          icon="results"
          active={this.props.page === 'monthlyReport'}
          onClick={() => this.visit('IG results', this.props.mobile ? '/instagram' : '/results')}
          mini={isMini}
        />
        {!this.props.mobile && (
          <>
            <MenuItem
              text="Create Offer"
              icon="createOffer"
              active={this.props.page === 'createOffer'}
              onClick={() => this.visit('Create offer', '/offers/create')}
              mini={isMini}
            />
            <MenuItem
              text="Offers"
              icon="offers"
              active={this.props.page === 'offers'}
              onClick={() => this.visit('Active offers', '/offers/active')}
              mini={isMini}
            />
            <MenuItem
              text="Profile"
              icon="profile"
              active={this.props.page === 'profile'}
              onClick={() => this.visit('Profile', '/profile')}
              mini={isMini}
            />
          </>
        )}
        <MenuItem
          text="Plan + Accounting"
          icon="payment"
          active={this.props.page === 'billing'}
          onClick={() => this.props.push('/billing')}
          mini={isMini}
        />
        <MenuItem
          text="Logout"
          mini={isMini}
          icon="logout"
          onClick={() => this.logout()}
          active={false}
        />
      </Container>
    );
  }
}

export default connect(({ business }: any) => ({ business }), {
  push,
  logout,
  fetchBusinessInfo,
})(Sidebar);
